import api from "../../services/api";
import {
  GET_CURRENT_INSTRUCTOR_FAILURE,
  GET_CURRENT_INSTRUCTOR_REQUEST,
  GET_CURRENT_INSTRUCTOR_SUCCESS,
  GET_INSTRUCTORS_FAILURE,
  GET_INSTRUCTORS_REQUEST,
  GET_INSTRUCTORS_SUCCESS,
  GET_INSTRUCTOR_COURSES_REQUEST,
  GET_INSTRUCTOR_COURSES_SUCCESS,
  GET_INSTRUCTOR_DETAIL_FAILURE,
  GET_INSTRUCTOR_DETAIL_REQUEST,
  GET_INSTRUCTOR_DETAIL_SUCCESS,
  GET_INSTRUCTOR_WITH_COURSES_FAILURE,
  GET_INSTRUCTOR_WITH_COURSES_REQUEST,
  GET_INSTRUCTOR_WITH_COURSES_SUCCESS,
  GET_MY_STUDENTS_FAILURE,
  GET_MY_STUDENTS_REQUEST,
  GET_MY_STUDENTS_SUCCESS,
  RESET_ALL_ACTIONS,
  UPDATE_INSTRUCTOR_DETAIL_FAILURE,
  UPDATE_INSTRUCTOR_DETAIL_REQUEST,
  UPDATE_INSTRUCTOR_DETAIL_SUCCESS,
} from "./ActionType";

const instructorDetailUpdateRequest = () => {
  return {
    type: UPDATE_INSTRUCTOR_DETAIL_REQUEST,
  };
};

const instructorDetailUpdateSuccess = (instructor) => {
  return {
    type: UPDATE_INSTRUCTOR_DETAIL_SUCCESS,
    payload: instructor,
  };
};

const instructorDetailUpdateFailure = (error) => {
  return {
    type: UPDATE_INSTRUCTOR_DETAIL_FAILURE,
    payload: error,
  };
};

export const updateInstructorDetail = (instructor) => async (dispatch) => {
  dispatch(instructorDetailUpdateRequest());
  try {
    // Assuming you have an API service to update instructor details
    const response = await api.put(`/instructors`, instructor, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 600000, // 10 minutes for instructor profile updates with image uploads
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
    dispatch(instructorDetailUpdateSuccess(response.data));
  } catch (error) {
    dispatch(instructorDetailUpdateFailure(error.response.data));
  }
};

const getCurrentInstructorDetailRequest = () => {
  return {
    type: GET_CURRENT_INSTRUCTOR_REQUEST,
  };
};
const getCurrentInstructorDetailSuccess = (instructor) => {
  return {
    type: GET_CURRENT_INSTRUCTOR_SUCCESS,
    payload: instructor,
  };
};

const getCurrentInstructorDetailFailure = (error) => {
  return {
    type: GET_CURRENT_INSTRUCTOR_FAILURE,
    payload: error,
  };
};

export const getCurrentInstructorDetail = () => async (dispatch) => {
  dispatch(getCurrentInstructorDetailRequest());
  try {
    const response = await api.get(`/instructors/current`);
    dispatch(getCurrentInstructorDetailSuccess(response.data));
  } catch (error) {
    dispatch(getCurrentInstructorDetailFailure(error.response.data));
  }
};

const getMyStudentsRequest = () => {
  return {
    type: GET_MY_STUDENTS_REQUEST,
  };
};

const getMyStudentsSuccess = (students) => {
  return {
    type: GET_MY_STUDENTS_SUCCESS,
    payload: students,
  };
};

const getMyStudentsFailure = (error) => {
  return {
    type: GET_MY_STUDENTS_FAILURE,
    payload: error,
  };
};

export const getMyStudents = (page) => async (dispatch) => {
  dispatch(getMyStudentsRequest());
  try {
    const response = await api.get(`/instructors/my-students?page=${page}`);
    dispatch(getMyStudentsSuccess(response.data));
  } catch (error) {
    dispatch(getMyStudentsFailure(error.response.data));
  }
};

const getInstructorWithCoursesRequest = () => {
  return {
    type: GET_INSTRUCTOR_WITH_COURSES_REQUEST,
  };
};

const getInstructorWithCoursesSuccess = (instructor) => {
  return {
    type: GET_INSTRUCTOR_WITH_COURSES_SUCCESS,
    payload: instructor,
  };
};

const getInstructorWithCoursesFailure = (error) => {
  return {
    type: GET_INSTRUCTOR_WITH_COURSES_FAILURE,
    payload: error,
  };
};

export const getInstructorWithCourses =
  (instructorId, page) => async (dispatch) => {
    dispatch(getInstructorWithCoursesRequest());
    try {
      const response = await api.get(
        `/instructors/${instructorId}/details?page=${page}`
      );
      dispatch(getInstructorWithCoursesSuccess(response.data));
    } catch (error) {
      dispatch(getInstructorWithCoursesFailure(error.response.data));
    }
  };

const getInstructorsRequest = () => {
  return {
    type: GET_INSTRUCTORS_REQUEST,
  };
};

const getInstructorsSuccess = (instructors) => {
  return {
    type: GET_INSTRUCTORS_SUCCESS,
    payload: instructors,
  };
};

const getInstructorsFailure = (error) => {
  return {
    type: GET_INSTRUCTORS_FAILURE,
    payload: error,
  };
};

export const getInstructors = (page) => async (dispatch) => {
  dispatch(getInstructorsRequest());
  try {
    const response = await api.get(`/instructors?page=${page}`);
    dispatch(getInstructorsSuccess(response.data));
  } catch (error) {
    dispatch(getInstructorsFailure(error.response.data));
  }
};

export const resetAllActions = () => {
  return {
    type: RESET_ALL_ACTIONS,
  };
};
